<template>

  <form id="addSessionForm" @submit.prevent="submitForm">
    <div class="steps-w" v-if="filteredSteps.length > 0">
      <div class="step-triggers">
        <a :class="{ 'active': step.key == currentStep.key, 'step-trigger': 1==1}" v-for="step in filteredSteps" @click="customStep(step.key)">{{step.name}}</a>
      </div>
      <div class="step-contents">

        <div class="active" >

            <div class="form-group">
                <label for=""> Import Location</label>
                <div class="row m-0">
                    <div class="col-sm-10 pl-0">
                        <input type="text" class="form-control" value="/Import/Photodesk/" disabled>
                    </div>
                    <div class="col-sm-2">
                        <button class="btn btn-primary" style="height:33px;" @click.prevent="scanFolder">Scan Folder</button>
                    </div>
                </div>

            </div>

            <div class="form-group">
                <label for=""> Import Details</label>
                <div class="">
                    <div class="user-intro-info">

                        <div class="row padded" >
                            <div class="col-6 b-r">
                                <div class="el-tablo centered highlight">
                                <div class="label">Folders</div>
                                <div class="value">{{folders.length}}</div>
                                </div>
                            </div>
                            <div class="col-6">
                                <div class="el-tablo centered highlight">
                                <div class="label">Valid Assets</div>
                                <div class="value">{{files.length}}</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>

        <div class="form-buttons-w text-right">
          <button class="btn btn-primary" @click.prevent="previousStep" v-if="currentStep.index > 1">Previous</button>

          <button class="btn btn-primary" @click.prevent="nextStep" v-if="currentStep.index < filteredSteps.length">Continue</button>
          <button class="btn btn-primary" type="submit" v-else-if="currentStep.index == filteredSteps.length">Import</button>
          <button class="btn btn-primary" v-else></button>
        </div>
      </div>
    </div>
  </form>
</template>

<script>
import FormMixin from '@/mixins/forms.js'

export default {
  mixins: [FormMixin],
  props: ['session'],
  data () {
    return {
      steps: [
        { name: 'Import', key: 'photodesk-import', group: 'photodesk' }
      ],
      filteredSteps: [],
      currentStep: {
        key: '',
        index: 0
      },
      folders: [],
      files: []
    }
  },
  mounted () {
    this.initializeSteps()
  },
  methods: {
    initializeSteps () {
      var self = this
      var index = 1
      self.filteredSteps = self.steps

      self.currentStep.key = self.filteredSteps[0].key
      self.currentStep.index = 1
      self.$store.dispatch('updateLoading', 'false')
    },
    previousStep () {
      var self = this
      let step = self.filteredSteps.find(
        filter => parseInt(filter.index) === this.currentStep.index - 1
      )

      this.currentStep.index--
      this.currentStep.key = step.key
    },
    nextStep () {
      var self = this

      let step = self.filteredSteps.find(
        filter => parseInt(filter.index) === this.currentStep.index + 1
      )
      this.currentStep.index++
      this.currentStep.key = step.key
    },
    customStep (key) {
      var self = this

      let step = self.filteredSteps.find(filter => filter.key === key)
      this.currentStep.index = step.index
      this.currentStep.key = step.key
    },
    scanFolder: function () {
      var self = this

      const url = '/photodesk/import/scanfolder'
      let data = {
        id_photodesk_session: self.session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.folders = response.data.folders
          self.files = response.data.files
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },
    submitForm () {
      var self = this

      const url = '/photodesk/import/trigger'
      let data = {
        id_photodesk_session: self.session
      }

      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.$router.push('/photodesk/sessions/' + self.session)
        })
        .catch(function (error) {
          self.$store.dispatch('updateToast', {
            text: (error.response && error.response.data.error) || 'Something went wrong',
            show: true
          })
        })
    },
    passEmit (data) {
      this.$emit('headerInterface', data)
    }
  }
}
</script>
